import * as React from "react";
import * as ReactDOM from "react-dom";
import CopyToClipboard from "react-copy-to-clipboard";

import { AgentDetails, ExternalServiceDetails, Place, PlaceGroup, SignUp } from "../data";
import { notifyServerErrorOrDefault } from "../helpers";
import jQuery from "jquery";

const ACTION_EDITABLE_SOURCE: string = JSON.stringify([
    { value: "new", text: "New" },
    { value: "verifying", text: "Verifying" },
    { value: "ok", text: "Ok" },
    { value: "frog", text: "Frog" },
    { value: "unknown", text: "Unknown" },
]);

interface NewUserSignUpProps {
    signUp: SignUp;
}

class NewUserSignUpActions extends React.Component<NewUserSignUpProps, {}> {
    constructor(props: NewUserSignUpProps) {
        super(props);

        this.handleAction = this.handleAction.bind(this);
    }

    handleAction(e: React.SyntheticEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        const target = e.target;

        const name = jQuery(target).data("name");
        let key = "status";
        let val: string | number = "";
        switch (name) {
            case "frog":
            case "unknown":
            case "duplicate":
                key = "status";
                val = name;
                break;
            case "approve":
                key = "status";
                val = "complete";
                break;
            case "assign":
                key = "moderator";
                val = -1;
                break;
        }

        if (key === "status") {
            jQuery("#modalAction").val("status");
            jQuery("#modalValue").val(val);
            jQuery("#modalId").val(this.props.signUp.id);
            jQuery("#modalUrl").val(`/backend/toolbox/signups/${ this.props.signUp.id }`);
            jQuery("#statusModal").modal("show");
        }
        else {
            if (key === "moderator") {
                jQuery.post(`/backend/toolbox/signups/${ this.props.signUp.id }`, {
                    name: key,
                    value: val,
                });
            }
        }
    }

    render(): JSX.Element {
        const signUp: SignUp = this.props.signUp;

        return (
            <div
                className="row signup"
                id={ `signupRow${ signUp.id }` }
                style={ { paddingTop: "5px", paddingBottom: "5px" } }
            >
                <div className="col-sm-3 col-xs-6">
                    <a
                        className="btn btn-primary btn-block collapsed"
                        style={ { textAlign: "left" } }
                        data-toggle="collapse"
                        data-target={ `#signupDetails${ signUp.id }` }
                        aria-expanded="false"
                        aria-controls={ `signupDetails${ signUp.id }` }
                    >
                        @{ signUp.codename }
                    </a>
                </div>
                <div className="hidden-xs col-sm-6" style={ { fontSize: "0.9em" } }>
                    <div className="row">
                        <div className="col-xs-9">
                            { signUp.country } / { signUp.city }
                        </div>
                        <div className="col-xs-3">{ signUp.status }</div>
                        <div className="col-xs-12">{ signUp.moderatorCodename }</div>
                    </div>
                </div>
                <div className="col-sm-3 col-cs-6" style={ { textAlign: "right" } }>
                    <div className="btn-group pull-right">
                        <button type="button" className="btn btn-info">
                            Actions
                        </button>
                        <button
                            type="button"
                            className="btn btn-info dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="caret"/>
                            <span className="sr-only">Toggle Dropdown</span>
                        </button>
                        <ul className="dropdown-menu">
                            <li>
                                <a href="#" onClick={ this.handleAction } data-name="assign">
                                    Assign to me
                                </a>
                            </li>
                            <li role="separator" className="divider"/>
                            <li>
                                <a href="#" onClick={ this.handleAction } data-name="approve">
                                    Approve
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={ this.handleAction } data-name="duplicate">
                                    Duplicate
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={ this.handleAction } data-name="frog">
                                    Frog
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={ this.handleAction } data-name="unknown">
                                    Unknown
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

interface NewUserSignUpAgentDetailsProps {
    details: AgentDetails;
    signUp: SignUp;
}

class NewUserSignUpAgentDetails extends React.Component<NewUserSignUpAgentDetailsProps, {}> {
    componentDidMount(): void {
        jQuery(".signup-editable-detail", ReactDOM.findDOMNode(this)).editable();
    }

    render(): JSX.Element {
        const details: AgentDetails = this.props.details;
        const signUp: SignUp = this.props.signUp;

        return (
            <tr>
                <td>
                    <a
                        className="signup-editable-detail"
                        href="#"
                        data-type="text"
                        data-pk={ details.id }
                        data-name="verify"
                        data-url={ `/backend/toolbox/signups/${ signUp.id }/detail/${ details.id }` }
                    >
                        { details.verify }
                    </a>
                </td>
                <td>
                    <a
                        className="signup-editable-detail"
                        href="#"
                        data-type="text"
                        data-pk={ details.id }
                        data-name="agent_notes"
                        data-url={ `/backend/toolbox/signups/${ signUp.id }/detail/${ details.id }` }
                    >
                        { details.agentNotes }
                    </a>
                </td>
                <td>
                    <a
                        className="signup-editable-detail"
                        href="#"
                        data-type="textarea"
                        data-placeholder="Moderators notes"
                        data-rows="3"
                        data-pk={ details.id }
                        data-name="moderator_notes"
                        data-url={ `/backend/toolbox/signups/${ signUp.id }/detail/${ details.id }` }
                    >
                        { details.moderatorNotes }
                    </a>
                </td>
                <td style={ { textAlign: "right" } }>
                    <a
                        className="signup-editable-detail"
                        href="#"
                        data-type="select"
                        data-pk={ details.id }
                        data-value={ details.status }
                        data-source={ ACTION_EDITABLE_SOURCE }
                        data-name="status"
                        data-url={ `/backend/toolbox/signups/${ signUp.id }/detail/${ details.id }` }
                    >
                        { details.status }
                    </a>
                </td>
            </tr>
        );
    }
}

interface NewUserSignUpFactionDetailsProps {
    details: ExternalServiceDetails;
    signUp: SignUp;
}

class NewUserSignUpFactionDetails extends React.Component<NewUserSignUpFactionDetailsProps, {}> {
    componentDidMount(): void {
        jQuery(".signup-editable-detail", ReactDOM.findDOMNode(this)).editable();
    }

    render(): JSX.Element {
        const details: ExternalServiceDetails = this.props.details;
        const signUp: SignUp = this.props.signUp;

        return (
            <tr>
                <td>Possible Faction</td>
                <td>{ details.agentNotes }</td>
                <td>
                    <a
                        className="signup-editable-detail"
                        href="#"
                        data-type="textarea"
                        data-placeholder="Moderators notes"
                        data-rows="3"
                        data-pk={ details.id }
                        data-name="moderator_notes"
                        data-url={ `/backend/toolbox/signups/${ signUp.id }/detail/${ details.id }` }
                    >
                        { details.moderatorNotes }
                    </a>
                </td>
                <td style={ { textAlign: "right" } }>
                    <a
                        className="signup-editable-detail"
                        href="#"
                        data-type="select"
                        data-pk={ details.id }
                        data-value={ details.status }
                        data-source={ ACTION_EDITABLE_SOURCE }
                        data-name="status"
                        data-url={ `/backend/toolbox/signups/${ signUp.id }/detail/${ details.id }` }
                    >
                        { details.status }
                    </a>
                </td>
            </tr>
        );
    }
}

interface NewUserSignUpReswueDetailsProps {
    details: ExternalServiceDetails;
    signUp: SignUp;
}

class NewUserSignUpReswueDetails extends React.Component<NewUserSignUpReswueDetailsProps, {}> {
    componentDidMount(): void {
        jQuery(".signup-editable-detail", ReactDOM.findDOMNode(this)).editable();
    }

    render(): JSX.Element {
        const details: ExternalServiceDetails = this.props.details;
        const signUp: SignUp = this.props.signUp;

        return (
            <tr>
                <td>Trustmaster</td>
                <td>{ details.agentNotes }</td>
                <td>
                    <a
                        className="signup-editable-detail"
                        href="#"
                        data-type="textarea"
                        data-placeholder="Moderators notes"
                        data-rows="3"
                        data-pk={ details.id }
                        data-name="moderator_notes"
                        data-url={ `/backend/toolbox/signups/${ signUp.id }/detail/${ details.id }` }
                    >
                        { details.moderatorNotes }
                    </a>
                </td>
                <td style={ { textAlign: "right" } }>
                    <a
                        className="signup-editable-detail"
                        href="#"
                        data-type="select"
                        data-pk={ details.id }
                        data-value={ details.status }
                        data-source={ ACTION_EDITABLE_SOURCE }
                        data-name="status"
                        data-url={ `/backend/toolbox/signups/${ signUp.id }/detail/${ details.id }` }
                    >
                        { details.status }
                    </a>
                </td>
            </tr>
        );
    }
}

class NewUserSignUpDetails extends React.Component<NewUserSignUpProps, {}> {
    get agentDetails(): JSX.Element[] {
        const signUp: SignUp = this.props.signUp;
        return signUp.agentDetails.map(
            (details, idx: number): JSX.Element => {
                return <NewUserSignUpAgentDetails signUp={ signUp } details={ details } key={ idx }/>;
            }
        );
    }

    get factionDetails(): JSX.Element[] {
        const signUp: SignUp = this.props.signUp;
        return signUp.factionDetails.map(
            (details, idx: number): JSX.Element => {
                return <NewUserSignUpFactionDetails signUp={ signUp } details={ details } key={ idx }/>;
            }
        );
    }

    get moderatorEditableSource(): string {
        return JSON.stringify([
            { value: 0, text: "Unassigned" },
            { value: this.props.signUp.currentUser, text: "Me" },
        ]);
    }

    get reswueDetails(): JSX.Element[] {
        const signUp: SignUp = this.props.signUp;
        return signUp.reswueDetails.map(
            (details, idx: number): JSX.Element => {
                return <NewUserSignUpReswueDetails signUp={ signUp } details={ details } key={ idx }/>;
            }
        );
    }

    componentDidMount(): void {
        jQuery(".signup-editable", ReactDOM.findDOMNode(this)).editable();
    }

    render(): JSX.Element {
        const signUp: SignUp = this.props.signUp;
        return (
            <div
                className="row signup collapse"
                id={ `signupDetails${ signUp.id }` }
                aria-expanded="false"
                style={ { paddingTop: "5px", height: "5px" } }
            >
                <div className="col-xs-12">
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <h5>Agent information:</h5>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Codename</h6>@
                                    <a
                                        className="signup-editable editable"
                                        href="#"
                                        data-type="text"
                                        data-pk={ signUp.id }
                                        data-name="codename"
                                        data-url={ `/backend/toolbox/signups/${ signUp.id }` }
                                    >
                                        { signUp.codename }
                                    </a>{ " " }
                                    <CopyToClipboard className="mx-1" text={ signUp.codename }>
                                        <a>Copy</a>
                                    </CopyToClipboard>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Moderator</h6>
                                    <a
                                        className="signup-editable editable"
                                        href="#"
                                        data-type="select"
                                        data-pk={ signUp.id }
                                        data-value=""
                                        data-source={ this.moderatorEditableSource }
                                        data-name="moderator"
                                        data-url={ `/backend/toolbox/signups/${ signUp.id }` }
                                    >
                                        { signUp.moderatorCodename }
                                    </a>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Status</h6>
                                    { signUp.status }
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Location</h6>
                                    { signUp.country } / { signUp.city }
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Timezone</h6>
                                    {signUp.timezone}
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Google ID</h6>
                                    { signUp.googleId }
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Telegram Username</h6>@
                                    <a
                                        className="signup-editable editable"
                                        href="#"
                                        data-type="text"
                                        data-pk={ signUp.id }
                                        data-name="telegram"
                                        data-url={ `/backend/toolbox/signups/${ signUp.id }` }
                                    >
                                        { signUp.telegram }
                                    </a>{ " " }
                                    <a
                                        target="_blank"
                                        href={ `https://t.me/${ signUp.telegram }` }
                                        rel="noopener noreferrer"
                                    >
                                        Link
                                    </a>
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Real name</h6>
                                    { signUp.name }
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>E-mail address</h6>
                                    { signUp.email }
                                    <CopyToClipboard className="mx-1" text={ signUp.email }>
                                        <a>Copy</a>
                                    </CopyToClipboard>
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Created</h6>
                                    { signUp.createdAt }
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <h6>Updated</h6>
                                    { signUp.updatedAt }
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <hr/>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12 col-sm-6">
                                    <h5>Additional notes from the agent:</h5>
                                    <a
                                        className="signup-editable"
                                        href="#"
                                        data-type="textarea"
                                        data-placeholder="No notes yet"
                                        data-pk={ signUp.id }
                                        data-name="agent_notes"
                                        data-url={ `/backend/toolbox/signups/${ signUp.id }` }
                                    >
                                        { signUp.agentNotes }
                                    </a>
                                </div>

                                <div className="col-xs-12 col-sm-6">
                                    <h5>Moderator notes:</h5>
                                    <a
                                        className="signup-editable"
                                        href="#"
                                        data-type="textarea"
                                        data-placeholder="No notes yet"
                                        data-pk={ signUp.id }
                                        data-name="moderator_notes"
                                        data-url={ `/backend/toolbox/signups/${ signUp.id }` }
                                    >
                                        { signUp.moderatorNotes }
                                    </a>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <hr/>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <h5>Verifying agents and services:</h5>
                                    <table
                                        className="table table-responsive"
                                        style={ { width: "100%" } }
                                    >
                                        <thead>
                                            <tr>
                                                <th>Agent/service</th>
                                                <th>Lookup info</th>
                                                <th>Result</th>
                                                <th style={ { textAlign: "right" } }>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { this.agentDetails }
                                            { this.reswueDetails }
                                            { this.factionDetails }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

interface NewUsersProps {
    countries: Place[];
    places: PlaceGroup[];
}

interface NewUsersState {
    countryId: number;
    filters: string[];
    page: number;
    pageCount: number;
    pageSize: number;
    placeId: number;
    search: string;
    signUpCount?: number;
    signUps: SignUp[];
}

class NewUsers extends React.Component<NewUsersProps, NewUsersState> {
    state: NewUsersState = {
        countryId: 0,
        filters: [ "mine", "queue", "unassigned" ],
        page: 1,
        pageCount: 1,
        pageSize: 25,
        placeId: 0,
        search: "",
        signUps: [],
    };

    constructor(props: NewUsersProps) {
        super(props);

        this.handleModalConfirm = this.handleModalConfirm.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
    }

    get countryOptions(): JSX.Element[] {
        return this.props.countries.map(
            (country): JSX.Element => {
                return (
                    <option value={ country.id } key={ country.id }>
                        { country.name }
                    </option>
                );
            }
        );
    }

    get filterAssignedToOptions(): JSX.Element[] {
        return this.filterOptions([
            [ "unassigned", "Unassigned" ],
            [ "assigned", "Assigned" ],
            [ "mine", "Assigned to me" ],
        ]);
    }

    get filterSelectionOptions(): JSX.Element[] {
        return this.filterOptions([
            [ "queue", "Queue" ],
            [ "unknown", "Unknown" ],
            [ "duplicate", "Duplicates" ],
            [ "frogs", "Frogs" ],
        ]);
    }

    get placeOptions(): JSX.Element[] | null {
        const country = this.props.places.find(
            (c: PlaceGroup): boolean => c.name === this.state.countryId
        );

        if (!country) {
            return null;
        }

        return country.place.map(
            (place): JSX.Element => {
                return (
                    <option value={ place.id } key={ place.id }>
                        { place.name }
                    </option>
                );
            }
        );
    }

    get signUps(): JSX.Element[] {
        return this.state.signUps.map(
            (signUp): JSX.Element => {
                return (
                    <div key={ signUp.id }>
                        <NewUserSignUpActions signUp={ signUp }/>
                        <NewUserSignUpDetails signUp={ signUp }/>
                    </div>
                );
            }
        );
    }

    componentDidMount(): void {
        jQuery("#country, #place, #quickfilter").selectpicker();
        jQuery("#country").on("changed.bs.select", (e): void => {
            jQuery("#place").val(0);

            this.setState({
                countryId: +e.target.value,
                placeId: 0,
                page: 1,
            });
        });

        jQuery("#place").on("changed.bs.select", (e): void => {
            this.setState({
                placeId: +e.target.value,
                page: 1,
            });
        });

        jQuery("#quickfilter").on("changed.bs.select", (e): void => {
            this.setState({
                filters: jQuery(e.target).val() as string[],
                page: 1,
            });
        });

        let timer;
        jQuery("#filterSearch").on("keyup", (e): void => {
            if (timer !== undefined) {
                clearTimeout(timer);
            }

            const value = e.target.value.trim();
            timer = setTimeout((): void => this.setState({ search: value, page: 1 }), 300);
        });
    }

    componentDidUpdate(prevProps: NewUsersProps, prevState: NewUsersState): void {
        if (prevProps.countries !== this.props.countries) {
            jQuery("#country").selectpicker("refresh");
        }

        if (
            prevProps.places !== this.props.places ||
            prevState.countryId !== this.state.countryId
        ) {
            jQuery("#place").selectpicker("refresh");
        }

        if (
            prevState.placeId !== this.state.placeId ||
            prevState.countryId !== this.state.countryId ||
            prevState.filters !== this.state.filters ||
            prevState.search !== this.state.search ||
            prevState.page !== this.state.page ||
            prevState.pageSize !== this.state.pageSize
        ) {
            this.refreshSignUps();
        }
    }

    UNSAFE_componentWillMount(): void {
        this.refreshSignUps();
    }

    filterOptions(opts: string[][]): JSX.Element[] {
        return opts.map(
            ([ value, label ]): JSX.Element => {
                return (
                    <option
                        key={ value }
                        value={ value }
                        selected={ this.state.filters.indexOf(value) !== -1 }
                    >
                        { label }
                    </option>
                );
            }
        );
    }

    handleModalConfirm(e: React.SyntheticEvent<HTMLButtonElement>): void {
        e.preventDefault();
        const key = jQuery("#modalAction").val() as string;
        const val = jQuery("#modalValue").val() as string;
        const url = jQuery("#modalUrl").val() as string;
        const id = +jQuery("#modalId").val();

        jQuery.post(url, { name: key, value: val });

        jQuery("#statusModal").modal("hide");

        this.setState(
            (state): NewUsersState => {
                return {
                    ...state,
                    signUpCount: Math.max(0, (state.signUpCount || 0) - 1),
                    signUps: state.signUps.filter((signUp): boolean => signUp.id !== id),
                };
            }
        );
    }

    handleNext(e: React.SyntheticEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        this.setState({ page: Math.min(this.state.page + 1, this.state.pageCount) });
    }

    handlePrevious(e: React.SyntheticEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        this.setState({ page: Math.max(this.state.page - 1, 1) });
    }

    refreshSignUps(): void {
        let url = `/backend/toolbox/signups/country/${ this.state.countryId }/city/${ this.state.placeId }`;

        url += `?page=${ this.state.page }&pageSize=${ this.state.pageSize }`;
        if (this.state.filters.length) {
            url +=
                "&quickFilter[]=" +
                this.state.filters
                    .map((f): string => encodeURIComponent(f))
                    .join("&quickFilter[]=");
        }

        if (this.state.search.length) {
            url += "&search=" + encodeURIComponent(this.state.search);
        }

        const parseDetails = (details): AgentDetails => {
            return {
                agentNotes: details.agent_notes,
                createdAt: details.created_at,
                id: +details.detail_id,
                moderatorId: +details.moderator_id,
                moderatorNotes: details.moderator_notes,
                status: details.status,
                updatedAt: details.updated_at,
                verify: details.verify,
            };
        };

        jQuery.getJSON(url).then(
            (data): void => {
                this.setState({
                    signUps: Object.keys(data.signups).map(
                        (key: string): SignUp => {
                            const signUp = data.signups[key];
                            return {
                                agentNotes: signUp.agent_notes,
                                city: signUp.city || "not set",
                                cityId: +(signUp.city_id || 0),
                                codename: signUp.codename,
                                country: signUp.country || "not set",
                                countryId: +(signUp.country_id || 0),
                                timezone: signUp.timezone || "not set",
                                createdAt: signUp.created_at,
                                currentUser: +data.currentUser,
                                email: signUp.email,
                                googleId: signUp.googleid,
                                telegram: signUp.telegram,
                                id: +signUp.id,
                                moderatorCodename: signUp.moderator_codename || "unassigned",
                                moderatorId: +signUp.moderator_id,
                                moderatorNotes: signUp.moderator_notes,
                                name: signUp.name,
                                status: signUp.status,
                                updatedAt: signUp.updated_at,

                                agentDetails: (signUp.details.agent || []).map(parseDetails),
                                factionDetails: (signUp.details.faction || []).map(parseDetails),
                                reswueDetails: (signUp.details.reswue || []).map(parseDetails),
                            };
                        }
                    ),
                    page: Math.max(data.pagination.page, 1),
                    signUpCount: data.pagination.total,
                    pageCount: Math.max(data.pagination.pages, 1),
                });
            },
            (ajax): void => {
                notifyServerErrorOrDefault(ajax, "Could not load signups");
            }
        );
    }

    render(): JSX.Element {
        const signUpCount =
            this.state.signUpCount !== undefined ? this.state.signUpCount : "Unknown";

        return (
            <div>
                <div className="row" id="header">
                    <div className="col-xs-12">
                        <h2>New users</h2>
                    </div>
                </div>
                <form id="location">
                    <div className="row">
                        <div className="form-group col-xs-1" style={ { fontSize: "1.6em" } }>
                            Filter:
                        </div>
                        <div className="form-group col-xs-3">
                            <select
                                id="country"
                                className="form-control"
                                data-live-search="true"
                                title="Country"
                                data-size="7"
                            >
                                { this.countryOptions }
                            </select>
                        </div>

                        <div className="col-xs-3">
                            <select
                                id="place"
                                className="form-control"
                                data-live-search="true"
                                title="City/area"
                                data-size="7"
                            >
                                { this.placeOptions }
                            </select>
                        </div>

                        <div className="col-xs-2">
                            <input
                                id="filterSearch"
                                type="text"
                                placeholder="codename or e-mail"
                                className="form-control"
                            />
                        </div>

                        <div className="col-xs-3">
                            <select className="form-control" id="quickfilter" multiple={ true }>
                                <optgroup label="Selection">{ this.filterSelectionOptions }</optgroup>
                                <optgroup label="Assigned to">
                                    { this.filterAssignedToOptions }
                                </optgroup>
                            </select>
                        </div>
                    </div>
                </form>
                <div className="row">
                    <div className="col-xs-12">
                        <hr/>
                    </div>
                </div>

                <div
                    className="modal fade"
                    id="statusModal"
                    tabIndex={ -1 }
                    role="dialog"
                    aria-labelledby="statusModalLabel"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h4 className="modal-title" id="statusModalLabel">
                                    Change status
                                </h4>
                            </div>
                            <div className="modal-body">
                                <input type="hidden" id="modalAction" value="" />
                                <input type="hidden" id="modalValue" value="" />
                                <input type="hidden" id="modalUrl" value="" />
                                <input type="hidden" id="modalId" value="" />
                                Are you sure you want to do this? Make sure codename, location and timezone are correct
                                before approving an agent.
                                <br/>This action will trigger e-mails to the agent in question and, possibly, to other
                                moderators.
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={ this.handleModalConfirm }
                                    className="btn btn-primary"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                { this.signUps }

                <div className="row" id="divider"/>

                <div className="row">
                    <div className="col-xs-12">
                        <nav aria-label="...">
                            <ul className="pager">
                                <li
                                    className={
                                        this.state.page > 1 ? "previous" : "previous disabled"
                                    }
                                >
                                    <a href="#" onClick={ this.handlePrevious }>
                                        Previous
                                    </a>
                                </li>
                                <li id="pages">
                                    Page { this.state.page } of { this.state.pageCount } (total{ " " }
                                    { signUpCount })
                                </li>
                                <li
                                    className={
                                        this.state.page < this.state.pageCount
                                            ? "next"
                                            : "next disabled"
                                    }
                                >
                                    <a href="#" onClick={ this.handleNext }>
                                        Next
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewUsers;
